export const ScreenNavigationArrow = ({ refProp, zIndex = 100 }) => {
  return (
    <div className="direction-arrow" ref={refProp}>
      <img src="/images/direction-arrow.svg" className="direction-arrow-image" alt="arrow" style={{ zIndex: zIndex }} />
    </div>
  );
};
